import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './utils/eelink-bridge'
import './utils/bluetooth-bridge'
import { installAppFont } from './utils/app-font'

installAppFont(router)
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/app-font.css'
import './assets/pagination.css'
import './assets/image-viewer-touch.css'
import { installImageViewerTouch } from './utils/image-viewer-touch'
import cookieUtils from './utils/cookie'

Vue.config.productionTip = false
Vue.use(ElementUI);
installImageViewerTouch(Vue)

// iOS WebView turns Element select taps into hover/focus; activate a stationary touch once.
let touchedSelectTarget = null
let touchedSelectPoint = null
document.addEventListener('touchstart', event => {
  const target = event.target
  const option = target && target.closest ? target.closest('.el-select-dropdown__item:not(.is-disabled)') : null
  const select = target && target.closest ? target.closest('.el-select') : null
  const clear = target && target.closest ? target.closest('.el-icon-circle-close') : null
  const enabledSelect = select && !select.querySelector('.el-input.is-disabled') ? select : null
  if (enabledSelect) {
    document.querySelectorAll('.el-select .el-input.is-focus').forEach(input => {
      const openSelect = input.closest('.el-select')
      if (openSelect && openSelect !== enabledSelect) openSelect.click()
    })
    event.preventDefault()
  }
  touchedSelectTarget = option || clear || enabledSelect
  const touch = event.touches[0]
  touchedSelectPoint = touchedSelectTarget && touch ? { x: touch.clientX, y: touch.clientY } : null
}, { passive: false })
document.addEventListener('touchend', event => {
  const touch = event.changedTouches[0]
  if (touchedSelectTarget && touchedSelectPoint && touch &&
    Math.abs(touch.clientX - touchedSelectPoint.x) < 10 && Math.abs(touch.clientY - touchedSelectPoint.y) < 10) {
    event.preventDefault()
    const select = touchedSelectTarget.closest('.el-select')
    const selectInput = select
      ? select.querySelector('.el-input__inner')
      : document.querySelector('.el-select .el-input.is-focus .el-input__inner')
    if (selectInput) selectInput.disabled = true
    touchedSelectTarget.click()
    if (selectInput) selectInput.disabled = false
  }
  touchedSelectTarget = null
  touchedSelectPoint = null
}, { passive: false })
document.addEventListener('touchcancel', () => {
  touchedSelectTarget = null
  touchedSelectPoint = null
}, { passive: true })

// 注册全局cookie工具
Vue.prototype.$cookie = cookieUtils;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
